import { ExternalAttachmentTypeEnum } from '@onArte/shared/enums/common/attachments';

export class ExternalAttachmentModel {
  constructor(
    public id: string,
    public type: ExternalAttachmentTypeEnum,
    public path: string,
    public name: string,
  ) {}
}
